module.exports = __webpack_public_path__ + "9f76062163c892e772838b570b59e7eb.svg";